// ============================================================
// icon-gen.js – ERZEUGT von tools/icons_erzeugen.py, nicht von Hand bearbeiten.
// Gleiche Datei in Portal und Admin, damit beide Apps dieselben Icons
// kennen. Neues Icon: tools/emoji_map.py ergaenzen, Skript laufen lassen.
// Die Emoji-Tabelle unten ist neben Icon.jsx die EINZIG erlaubte
// Emoji-Stelle: sie uebersetzt Emojis aus Altdaten (DB, Server) in Icons.
// ============================================================
import {
  Accessibility, AlarmClock, Anchor, Angry, Archive, Armchair, ArrowLeft, ArrowRight, ArrowUpDown, Ban, BarChart3, Bell, BellOff, BookOpen, Bot, Brush, Building2, Cake, Calendar, CalendarClock, CalendarDays, Camera, Check, Circle, CircleCheck, CircleDot, CircleX, Clapperboard, ClipboardList, Clock, Cloud, CloudFog, CloudLightning, CloudRain, CloudSnow, CloudSun, CloudSunRain, Coffee, Compass, Construction, CreditCard, Crown, Disc3, DoorOpen, Drama, Euro, Eye, EyeOff, FilePen, FileText, Flag, Flame, FlaskConical, Flower2, Folder, FolderOpen, Footprints, Frown, Gift, Globe, GraduationCap, Hand, Handshake, Hash, Heart, HelpCircle, Home, Hourglass, Image, Inbox, Info, KeyRound, Keyboard, Landmark, Laugh, LifeBuoy, Lightbulb, LineChart, Link2, Lock, LockOpen, Mail, Mailbox, Map, MapPin, Medal, Megaphone, Meh, Menu, MessageCircle, Mic, Minus, Monitor, Moon, MousePointerClick, Music, Music2, Newspaper, Package, Palette, Paperclip, PartyPopper, Pause, PenLine, Pencil, Phone, PhoneOff, Pin, Play, Plug, Plus, Printer, Puzzle, Radio, Receipt, Repeat, Rocket, RotateCcw, Save, School, Scissors, ScrollText, Search, Send, Settings, Shirt, ShoppingBag, ShoppingCart, Shuffle, Signpost, Siren, SkipBack, SkipForward, Smartphone, Smile, Snowflake, Sofa, Sparkles, Square, SquareCheck, Star, Sun, Tag, Target, Tent, Thermometer, ThumbsUp, Ticket, Timer, Trash2, TreePalm, TrendingDown, TriangleAlert, Trophy, Tv, Type, Undo2, User, Users, Video, Wallet, Wine, Wrench, Zap,
} from "lucide-react";

export const GEN_MAP = {
  "accessibility": Accessibility,
  "alarm-clock": AlarmClock,
  "anchor": Anchor,
  "angry": Angry,
  "archive": Archive,
  "armchair": Armchair,
  "arrow-left": ArrowLeft,
  "arrow-right": ArrowRight,
  "arrow-up-down": ArrowUpDown,
  "ban": Ban,
  "bar-chart": BarChart3,
  "bell": Bell,
  "bell-off": BellOff,
  "book-open": BookOpen,
  "bot": Bot,
  "brush": Brush,
  "building": Building2,
  "cake": Cake,
  "calendar": Calendar,
  "calendar-clock": CalendarClock,
  "calendar-days": CalendarDays,
  "camera": Camera,
  "check": Check,
  "circle": Circle,
  "circle-check": CircleCheck,
  "circle-dot": CircleDot,
  "circle-x": CircleX,
  "clapperboard": Clapperboard,
  "clipboard-list": ClipboardList,
  "clock": Clock,
  "cloud": Cloud,
  "cloud-fog": CloudFog,
  "cloud-lightning": CloudLightning,
  "cloud-rain": CloudRain,
  "cloud-snow": CloudSnow,
  "cloud-sun": CloudSun,
  "cloud-sun-rain": CloudSunRain,
  "coffee": Coffee,
  "compass": Compass,
  "construction": Construction,
  "credit-card": CreditCard,
  "crown": Crown,
  "disc": Disc3,
  "door-open": DoorOpen,
  "drama": Drama,
  "euro": Euro,
  "eye": Eye,
  "eye-off": EyeOff,
  "file-pen": FilePen,
  "file-text": FileText,
  "flag": Flag,
  "flame": Flame,
  "flask": FlaskConical,
  "flower": Flower2,
  "folder": Folder,
  "folder-open": FolderOpen,
  "footprints": Footprints,
  "frown": Frown,
  "gift": Gift,
  "globe": Globe,
  "graduation-cap": GraduationCap,
  "hand": Hand,
  "handshake": Handshake,
  "hash": Hash,
  "heart": Heart,
  "help-circle": HelpCircle,
  "home": Home,
  "hourglass": Hourglass,
  "image": Image,
  "inbox": Inbox,
  "info": Info,
  "key": KeyRound,
  "keyboard": Keyboard,
  "landmark": Landmark,
  "laugh": Laugh,
  "life-buoy": LifeBuoy,
  "lightbulb": Lightbulb,
  "line-chart": LineChart,
  "link": Link2,
  "lock": Lock,
  "lock-open": LockOpen,
  "mail": Mail,
  "mailbox": Mailbox,
  "map": Map,
  "map-pin": MapPin,
  "medal": Medal,
  "megaphone": Megaphone,
  "meh": Meh,
  "menu": Menu,
  "message-circle": MessageCircle,
  "mic": Mic,
  "minus": Minus,
  "monitor": Monitor,
  "moon": Moon,
  "mouse-pointer-click": MousePointerClick,
  "music": Music,
  "music-2": Music2,
  "newspaper": Newspaper,
  "package": Package,
  "palette": Palette,
  "palm": TreePalm,
  "paperclip": Paperclip,
  "party-popper": PartyPopper,
  "pause": Pause,
  "pen-line": PenLine,
  "pencil": Pencil,
  "phone": Phone,
  "phone-off": PhoneOff,
  "pin": Pin,
  "play": Play,
  "plug": Plug,
  "plus": Plus,
  "printer": Printer,
  "puzzle": Puzzle,
  "radio": Radio,
  "receipt": Receipt,
  "refresh": RotateCcw,
  "repeat": Repeat,
  "rocket": Rocket,
  "save": Save,
  "school": School,
  "scissors": Scissors,
  "scroll": ScrollText,
  "search": Search,
  "send": Send,
  "settings": Settings,
  "shirt": Shirt,
  "shopping-bag": ShoppingBag,
  "shopping-cart": ShoppingCart,
  "shuffle": Shuffle,
  "signpost": Signpost,
  "siren": Siren,
  "skip-back": SkipBack,
  "skip-forward": SkipForward,
  "smartphone": Smartphone,
  "smile": Smile,
  "snowflake": Snowflake,
  "sofa": Sofa,
  "sparkles": Sparkles,
  "square": Square,
  "square-check": SquareCheck,
  "star": Star,
  "sun": Sun,
  "tag": Tag,
  "target": Target,
  "tent": Tent,
  "thermometer": Thermometer,
  "thumbs-up": ThumbsUp,
  "ticket": Ticket,
  "timer": Timer,
  "trash": Trash2,
  "trending-down": TrendingDown,
  "triangle-alert": TriangleAlert,
  "trophy": Trophy,
  "tv": Tv,
  "type": Type,
  "undo": Undo2,
  "user": User,
  "users": Users,
  "video": Video,
  "wallet": Wallet,
  "wine": Wine,
  "wrench": Wrench,
  "zap": Zap,
};

export const GEN_EMOJI = {
  "✅": "circle-check",
  "🎉": "party-popper",
  "🎊": "party-popper",
  "🎈": "party-popper",
  "🙌": "party-popper",
  "⚠": "triangle-alert",
  "🚨": "siren",
  "⛔": "ban",
  "🚫": "ban",
  "❌": "circle-x",
  "❎": "circle-x",
  "✔": "check",
  "✉": "mail",
  "📧": "mail",
  "📩": "mail",
  "📨": "mail",
  "📬": "mail",
  "📭": "mail",
  "💌": "mail",
  "📮": "mailbox",
  "📥": "inbox",
  "📤": "send",
  "⏳": "hourglass",
  "⌛": "hourglass",
  "⏰": "alarm-clock",
  "⏱": "timer",
  "🕐": "clock",
  "🕒": "clock",
  "🕔": "clock",
  "🕘": "clock",
  "⌚": "clock",
  "🔒": "lock",
  "🔐": "lock",
  "🔓": "lock-open",
  "🔑": "key",
  "📋": "clipboard-list",
  "📝": "file-pen",
  "📄": "file-text",
  "📃": "file-text",
  "📜": "scroll",
  "🧾": "receipt",
  "📅": "calendar",
  "📆": "calendar-days",
  "🗓": "calendar-clock",
  "⭐": "star",
  "🌟": "star",
  "💫": "sparkles",
  "✨": "sparkles",
  "🆕": "sparkles",
  "💡": "lightbulb",
  "⚡": "zap",
  "🔥": "flame",
  "🚀": "rocket",
  "💬": "message-circle",
  "🗨": "message-circle",
  "💭": "message-circle",
  "💶": "euro",
  "💰": "wallet",
  "💳": "credit-card",
  "🏦": "landmark",
  "🏛": "landmark",
  "📞": "phone",
  "☎": "phone",
  "📱": "smartphone",
  "📲": "smartphone",
  "📟": "smartphone",
  "📴": "phone-off",
  "🖼": "image",
  "📷": "camera",
  "📸": "camera",
  "🎬": "clapperboard",
  "📹": "video",
  "📺": "tv",
  "🖥": "monitor",
  "💻": "monitor",
  "⌨": "keyboard",
  "🖱": "mouse-pointer-click",
  "🖨": "printer",
  "💿": "disc",
  "📡": "radio",
  "📦": "package",
  "🛒": "shopping-cart",
  "🛍": "shopping-bag",
  "🎁": "gift",
  "🏷": "tag",
  "🎟": "ticket",
  "🎫": "ticket",
  "🏫": "school",
  "🏢": "building",
  "🏠": "home",
  "🏡": "home",
  "🚪": "door-open",
  "🪑": "armchair",
  "💺": "sofa",
  "📍": "map-pin",
  "📌": "pin",
  "🗺": "map",
  "🧭": "compass",
  "🌐": "globe",
  "🌍": "globe",
  "🌎": "globe",
  "🌏": "globe",
  "💃": "music",
  "🕺": "music",
  "🎵": "music",
  "🎶": "music-2",
  "🎼": "music",
  "🎤": "mic",
  "🩰": "footprints",
  "🚶": "footprints",
  "🎭": "drama",
  "🎪": "tent",
  "🎨": "palette",
  "👗": "shirt",
  "👑": "crown",
  "🏆": "trophy",
  "🏅": "medal",
  "🎯": "target",
  "🎂": "cake",
  "🍰": "cake",
  "🍸": "wine",
  "🍷": "wine",
  "🥂": "wine",
  "☕": "coffee",
  "👤": "user",
  "🧑": "user",
  "👨": "user",
  "👩": "user",
  "👧": "user",
  "👦": "user",
  "🙋": "hand",
  "👋": "hand",
  "🙏": "hand",
  "👥": "users",
  "👫": "users",
  "👪": "users",
  "🤝": "handshake",
  "👍": "thumbs-up",
  "👈": "arrow-left",
  "👉": "arrow-right",
  "👁": "eye",
  "👀": "eye",
  "🙈": "eye-off",
  "😀": "laugh",
  "😃": "laugh",
  "😄": "laugh",
  "😁": "laugh",
  "🤩": "laugh",
  "😊": "smile",
  "🙂": "smile",
  "😅": "smile",
  "😐": "meh",
  "😕": "meh",
  "🙁": "frown",
  "☹": "frown",
  "😞": "frown",
  "😔": "frown",
  "😢": "frown",
  "🔗": "link",
  "📎": "paperclip",
  "✂": "scissors",
  "✏": "pencil",
  "✍": "pen-line",
  "🖊": "pen-line",
  "🖋": "pen-line",
  "💾": "save",
  "📁": "folder",
  "📂": "folder-open",
  "🗂": "folder-open",
  "🗄": "archive",
  "🗑": "trash",
  "🔄": "refresh",
  "🔁": "repeat",
  "🔀": "shuffle",
  "↩": "undo",
  "↕": "arrow-up-down",
  "🔜": "arrow-right",
  "➡": "arrow-right",
  "▶": "play",
  "⏵": "play",
  "⏸": "pause",
  "⏭": "skip-forward",
  "⏮": "skip-back",
  "⏹": "square",
  "🔔": "bell",
  "🔕": "bell-off",
  "📢": "megaphone",
  "📣": "megaphone",
  "📚": "book-open",
  "📖": "book-open",
  "📘": "book-open",
  "📰": "newspaper",
  "🔍": "search",
  "🔎": "search",
  "📊": "bar-chart",
  "📈": "line-chart",
  "📉": "trending-down",
  "🔢": "hash",
  "🔠": "type",
  "🌤": "cloud-sun",
  "⛅": "cloud-sun",
  "🌥": "cloud-sun",
  "🌦": "cloud-sun-rain",
  "🌧": "cloud-rain",
  "⛈": "cloud-lightning",
  "🌨": "cloud-snow",
  "❄": "snowflake",
  "☁": "cloud",
  "🌫": "cloud-fog",
  "☀": "sun",
  "🌙": "moon",
  "🌡": "thermometer",
  "🏖": "palm",
  "🏝": "palm",
  "🌴": "palm",
  "🌸": "flower",
  "🌷": "flower",
  "⚙": "settings",
  "🔧": "wrench",
  "🛠": "wrench",
  "🔌": "plug",
  "🧪": "flask",
  "🧹": "brush",
  "🧩": "puzzle",
  "🤖": "bot",
  "🚧": "construction",
  "⚓": "anchor",
  "♿": "accessibility",
  "🪧": "signpost",
  "🆘": "life-buoy",
  "❓": "help-circle",
  "❔": "help-circle",
  "ℹ": "info",
  "➕": "plus",
  "➖": "minus",
  "⬛": "square",
  "⬜": "square",
  "⭕": "circle",
  "🔘": "circle-dot",
  "🎓": "graduation-cap",
  "🎌": "flag",
  "☑": "square-check",
  "❤": "heart",
  "💙": "heart",
  "🩷": "heart",
  "💞": "heart",
  "♥": "heart",
};
